"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = {
  black: "#000",
  anthrazit: "#333",
  darkgrey: "#858585",
  grey: "#C1C1C1",
  lightgrey: "#EAEAEA",
  white: "#FFF",
  red: "#DB1818",
  vividRed: "#FF1818",
  green: "#04BD07",
  cobayellow: "#FC3",
  lightAnthracite: "#474747",
  whiteGray: "#FAFAFA",
  vividOrange: "#FFBC22",
  darkOrange: "#FFAC12"
};
exports.bp = {
  small: "320px",
  medium1: "480px",
  medium2: "768px",
  large: "1024px",
  xlarge: "1441px"
};
var fallbackFont = "sans-serif";
exports.font = {
  book: "'Gotham Book', " + fallbackFont,
  medium: "'Gotham Medium', " + fallbackFont,
  bold: "'Gotham Bold', " + fallbackFont
}; // These names are not always really acurate, e.g. headingSeparator is use also for separating non headings

exports.units = {
  columns: 16,
  columnWidth: 90,
  columnMargin: 16,
  separator: 48,
  headingSeparator: 20,
  headingSeparatorSmall: 4,
  headingSeparatorLarge: 60,
  stagePaddingV: 140,
  stagePaddingH: 106,
  headerHeight: 88,
  mobile: {
    stagePaddingV: 48,
    separator: 16
  },
  xlarge: {
    stagePaddingH: 196
  },
  buildingUnit: 4
};
exports.bpMediaQueries = {
  small: "(max-width: 479px)",
  medium1: "(min-width: 480px) and (max-width: 767px)",
  medium2: "(min-width: 768px) and (max-width: 1023px)",
  medium: "(min-width: 768px) and (max-width: 1023px)",
  large: "(min-width: 1024px) and (max-width: 1399px)",
  xlarge: "(min-width: 1400px)"
};